<template lang="pug">
  div
    h3(
      v-if="organization.name"
      class="title-20px mb-6"
    ) {{ organization.name }}
    e-tabs(:items="items")
</template>

<script>
import ETabs from '~/components/elements/tabs/e-tabs'

export default {
  name: 'MOrganizationDetails',
  components: {
    ETabs
  },
  props: {
    organization: {
      type: Object,
      default: null
    }
  },
  computed: {
    items() {
      return [
        {
          text: this.$t('Documents'),
          component: 'block-admin-documents',
          componentProps: {
            entityId: this.organization.id,
            filterName: 'organizations.id'
          }
        },
        {
          text: this.$t('Users'),
          component: 'block-admin-users',
          componentProps: {
            entityId: this.organization.id,
            filterName: 'organization.id'
          }
        },
        {
          text: this.$t('Templates'),
          component: 'block-admin-templates',
          componentProps: {
            entityId: this.organization.id,
            filterName: 'organization.id'
          }
        },
        {
          text: this.$t('Billing'),
          component: 'block-organization-billing',
          componentProps: {
            organizationId: this.organization.id
          }
        },
        {
          text: this.$t('Invoices'),
          component: 'block-organization-invoices',
          componentProps: {
            organizationId: this.organization.id
          }
        },
        {
          text: this.$t('Payments'),
          component: 'block-organization-payments',
          componentProps: {
            organizationId: this.organization.id
          }
        },
        {
          text: this.$t('Acts'),
          component: 'block-organization-acts',
          componentProps: {
            organizationId: this.organization.id
          }
        },
        {
          text: this.$t('Periods'),
          component: 'block-organization-periods',
          componentProps: {
            organizationId: this.organization.id
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss"></style>
